import React, { createContext } from 'react';

// Create a context with a default value (optional)
const AppContext = createContext();

export default AppContext;